import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { CloseRounded } from "@mui/icons-material";
import { Avatar, Dialog, DialogContent, Divider, FormControl, Grid, InputLabel, Menu, MenuItem, Select, TextField } from "@mui/material";
import { api_urls } from "../../../../utils/api-urls/index.js";
import * as EcommerceActions from '../../../../redux/actions/ecommerceAction.js';
import MainDatatable from "../../../../components/common/MainDatatable.jsx";
import logo_icon from '../../../../assets/images/Logo/Bharat-Darshan-Logo.png';
import { DeleteSvg, EditSvg, FilterSvg, SwitchOffSvg, SwitchOnSvg, UploadImageSvg, ViewSvg } from "../../../../assets/svg/index.js";

const DisplaySingleCategory = () => {
    const navigate = useNavigate();
    const { id: productCategoryId } = useParams();
    const dispatch = useDispatch();
    const { ecommerceCategoryData, ecommerceSubCategoryData, ecommerceSubCategoryByCategoryIdData } = useSelector(state => state.ecommerceReducer);

    const [modalVisible, setModalVisible] = useState(false)
    const [subCategoryDetail, setSubCategoryDetail] = useState({ categoryId: '', subCategoryId: '', subCategoryName: '' });
    const [inputFieldError, setInputFieldError] = useState({ categoryId: '', subCategoryId: '', subCategoryName: '', image: '' });
    const [image, setImage] = useState({ file: '', bytes: '' });

    //* Handle Input Field : Error
    const handleInputFieldError = (input, value) => {
        setInputFieldError((prev) => ({ ...prev, [input]: value }))
    }

    //* Handle Input Field : Data
    const handleInputField = (e) => {
        const { name, value } = e.target;
        setSubCategoryDetail({ ...subCategoryDetail, [name]: value });
    };

    //! Handle Image : Normally
    const handleImage = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setImage({
                file: URL.createObjectURL(e.target.files[0]),
                bytes: e.target.files[0],
            });
        }

        handleInputFieldError("image", null)
    };

    //! Handle Image : Drop Feature
    const handleDrop = (e) => {
        e.preventDefault();
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            setImage({
                file: URL.createObjectURL(e.dataTransfer.files[0]),
                bytes: e.dataTransfer.files[0],
            });
        }

        handleInputFieldError("image", null)
    };

    //! Handle Edit - Sub Category
    const handleEdit = (data) => {
        setModalVisible(!modalVisible)
        console.log("Edit Data ::: ", data)

        setSubCategoryDetail({})

        setSubCategoryDetail({
            subCategoryId: data?._id || '',
            categoryId: data?.categoryId?._id || '',
            subCategoryName: data?.sub_category_name || '',
        });
        setImage({ file: api_urls + data?.image || logo_icon })
    }

    //! Handle Validation
    const handleValidation = () => {
        let isValid = true;
        const { subCategoryName, categoryId } = subCategoryDetail;

        if (!categoryId) {
            handleInputFieldError("categoryId", "Please Select Category Name")
            isValid = false;
        }
        if (!subCategoryName) {
            handleInputFieldError("subCategoryName", "Please Enter Sub Category Name")
            isValid = false;
        }
        return isValid;
    };

    //! Handle Submit - Updating Sub Category
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            console.log("Sub Category Data :: ", { ...subCategoryDetail, image })
            const { categoryId, subCategoryName, subCategoryId } = subCategoryDetail;

            let formData = new FormData()
            formData.append("categoryId", categoryId)
            formData.append("subCategoryId", subCategoryId)
            formData.append("sub_category_name", subCategoryName)
            formData.append("image", image?.bytes);

            const payload = {
                data: formData,
                onComplete: () => setModalVisible(false)
            }

            //! Dispatching API for Updating Category
            // dispatch(EcommerceActions.updateSubCategory(payload))
        }
    };

    //* Sub Category DataTable Columns
    const subCategoryColumns = [
        { name: 'S.No.', selector: row => ecommerceSubCategoryByCategoryIdData.length - ecommerceSubCategoryByCategoryIdData.indexOf(row), style: { backGroundColor: "#000", paddingLeft: "20px" } },
        { name: 'Category', selector: row => row?.productCategoryId?.title },
        { name: 'Title', selector: row => row?.product_sub_category_name },
        { name: 'Image', cell: row => <img src={row?.image ? api_urls + row?.image : logo_icon} alt="Profile" style={{ width: '50px', height: '50px', borderRadius: '50%' }} /> },
        { name: 'Status', selector: row => <div onClick={() => dispatch(EcommerceActions?.changeEcommercesubCategoryStatus({ productSubCategoryId: row?._id, productCategoryId }))} style={{ cursor: "pointer" }}>{row?.status == 'Active' ? <SwitchOnSvg /> : <SwitchOffSvg />}</div> },
        {
            name: 'Action',
            cell: row => <div style={{ display: "flex", gap: "20px", alignItems: "center" }} >
                <div onClick={() => dispatch(EcommerceActions.deleteEcommerceSubCategory({ productSubCategoryId: row?._id, productCategoryId }))} style={{ cursor: "pointer" }}><DeleteSvg /></div>
            </div >,
            width: "180px"
        },
    ];

    useEffect(() => {
        //! Dispatching API for Getting Category
        // dispatch(EcommerceActions.getEcommerceCategory())

        //! Dispatching API for Getting Sub Category
        // dispatch(EcommerceActions.getEcommerceSubCategory())

        //! Dispatching API for Getting Sub Category By Category Id
        dispatch(EcommerceActions.getEcommerceSubCategoryByCategoryId({ productCategoryId }))
    }, []);

    return (
        <>
            <MainDatatable data={ecommerceSubCategoryByCategoryIdData} columns={subCategoryColumns} title={'Ecommerce Single Category'} />

            {/* <Dialog
                open={modalVisible}>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item lg={12} sm={12} md={12} xs={12} sx={{ marginBottom: "20px" }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <div style={{ fontSize: "23px", fontWeight: "600" }}>Edit Ecommerce Sub Category</div>
                                <div onClick={() => setModalVisible(false)}><CloseRounded /></div>
                            </div>
                        </Grid>

                        <Grid item lg={12} sm={12} md={12} xs={12} >
                            <div style={{ color: "#000", border: "1px solid #C4C4C4", borderRadius: "3px" }}>
                                {image?.file || image?.bytes ?
                                    <label onDragOver={(e) => e.preventDefault()} onDrop={handleDrop} htmlFor="upload-image" style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px", cursor: "pointer" }}>
                                        <Avatar src={image.file} style={{ height: '220px', width: "220px", borderRadius: "initial" }} />
                                    </label>
                                    :
                                    <label onDragOver={(e) => e.preventDefault()} onDrop={handleDrop} htmlFor="upload-image" style={{ display: "flex", flexDirection: "column", gap: "20px", alignItems: "center", padding: "50px 0", cursor: "pointer" }}>
                                        <UploadImageSvg h="80" w="80" color="#C4C4C4" />
                                        <div style={{ fontWeight: "600", fontSize: "18px" }}>Choose Your Image to Upload</div>
                                        <div style={{ fontWeight: "500", fontSize: "16px", color: 'grey' }}>Or Drop Your Image Here</div>
                                    </label>}
                                <input id="upload-image" onChange={handleImage} hidden accept="image/*" type="file" />
                            </div>
                            {inputFieldError?.image && <div style={{ color: "#D32F2F", fontSize: "10.75px", padding: "10px 0 0 12px", }}>{inputFieldError?.image}</div>}
                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12} >
                            <FormControl fullWidth>
                                <InputLabel id="select-label">Select Category Name</InputLabel>
                                <Select
                                    label="Select Category Name" variant="outlined" fullWidth
                                    name='categoryId'
                                    value={subCategoryDetail?.categoryId}
                                    onChange={handleInputField}
                                    error={inputFieldError?.categoryId ? true : false}
                                    onFocus={() => handleInputFieldError("categoryId", null)}
                                >
                                    {categoryData.length === 0 ? <MenuItem disabled>---Please First Select Redirect Page---</MenuItem> : <MenuItem disabled>---Select Category Name---</MenuItem>}
                                    {categoryData.map((value, index) => {
                                        return <MenuItem key={index} value={value?._id}>{value?.category_name}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                            {inputFieldError?.categoryId && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.categoryId}</div>}
                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12} >
                            <TextField
                                label="Sub Category Name" variant='outlined' fullWidth
                                name='subCategoryName'
                                value={subCategoryDetail?.subCategoryName}
                                onChange={handleInputField}
                                error={inputFieldError.subCategoryName ? true : false}
                                helperText={inputFieldError.subCategoryName}
                                onFocus={() => handleInputFieldError("subCategoryName", null)}
                            />
                        </Grid>

                        <Grid item lg={12} sm={12} md={12} xs={12} sx={{ marginTop: "15px" }}>
                            <Grid container spacing={2}>
                                <Grid item lg={6} sm={6} md={6} xs={6} >
                                    <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px", textAlign: "center", fontFamily: "Philosopher" }}>Submit</div>
                                </Grid>
                                <Grid item lg={6} sm={6} md={6} xs={6} >
                                    <div onClick={() => setModalVisible(false)} style={{ fontWeight: "500", backgroundColor: "#EDF2F5", color: "#000", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px", textAlign: "center", fontFamily: "Philosopher" }}>
                                        Close
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog> */}
        </ >
    );
}

export default DisplaySingleCategory;